import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import { PlayerModel } from "@/model/playerModel";
interface AnchorProps {
  roomdata: PlayerModel;
  type: Number;
}

export default /*#__PURE__*/_defineComponent({
  name: 'AnchorTab',
  props: {
    roomdata: { type: null, required: true },
    type: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  roomdata: PlayerModel;
  type: Number;
}


const primaryColor = '#F0082E';

onMounted(() => {

})

const __returned__ = { props, primaryColor }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})